import { useEffect, useState } from "react";
import { api, rupee } from "@/lib/api";

export default function InvoicesAdmin() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/invoices").then((r) => setItems(r.data)); }, [api]);
  return (
    <div>
      <h1 className="font-serif text-3xl mb-2">Invoices</h1>
      <p className="text-xs text-[#8C867D] mb-6 uppercase tracking-widest">Auto-generated for every confirmed payment</p>
      <div className="admin-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[#8C867D] text-xs uppercase tracking-widest text-left">
            <tr><th className="p-3">Invoice</th><th>Order</th><th>Customer</th><th>Total</th><th>Payment</th><th>Date</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((o) => (
              <tr key={o.id} className="border-t border-[#27272A]">
                <td className="p-3 font-mono text-xs text-[#C5A059]">{o.invoice_id}</td>
                <td className="font-mono text-xs">{o.order_id}</td>
                <td className="text-xs">{o.customer_name || "—"}</td>
                <td>{rupee(o.total)}</td>
                <td className="text-xs uppercase">{o.payment_method}</td>
                <td className="text-xs">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="pr-3 text-right">
                  <a href={`/admin/invoice/${o.order_id}`} className="text-xs uppercase tracking-widest text-[#C5A059]" data-testid={`invoice-view-${o.order_id}`}>View / Print</a>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-[#8C867D] text-sm">No confirmed payments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
